import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
`;

export const Content = styled.div`
  flex: 1 0 auto;
  flex-direction: row;
  display: flex;
`;

export const Wrapper = styled.div`
  padding-top: 110px;
  padding-left: 315px;
  flex: 1 auto;
  min-width: 0;
  flex-direction: column;
  display: flex;
`;

export const Body = styled.div`
  flex: 1 0 auto;
  display: flex !important;
`;
